import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

/**
 *   - data-anim-trigger: parent element for the animation
 *   - data-anim: animation type (e.g., 'heading', 'fade') 
 *   - data-anim-delay: delay before animation starts (in seconds)
 */

export const initInviewAnimations = () => {

  const animParents = document.querySelectorAll('[data-anim-trigger]')

	if (animParents.length === 0 || window.isLivePreview) return

	document.fonts.ready.then(() => {
		animParents.forEach((element) => {
			const animOffset = element.dataset.animOffset
			const animElements = element.querySelectorAll('[data-anim]')
			createTimeline(element, animElements, animOffset)
		})
	})
}

const createTimeline = (parent, animElements, offset = '60%') => {
	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: parent,
			start: `top ${offset}`,
			invalidateOnRefresh: true,
			once: true
		}
	})

	animElements.forEach((element) => {
		const type = element.dataset.anim
		const delay = parseFloat(element.dataset.animDelay)

		createAnimation(tl, element, type, delay)
	})
}

const createAnimation = (tl, element, type, delay = 0) => {

  switch (type) {
		
    case 'heading':
			let split = SplitText.create(element, { type: 'words', aria: 'none', wordsClass: 'word++' })
			element.classList.add('blur')
			tl.fromTo(split.words, {
				opacity: 0,
				willChange: 'filter, transform',
				filter: 'blur(8px)'
			}, {
				ease: 'sine',
				opacity: 1,
				duration: 1,
				filter: 'blur(0px)',
				stagger: 0.04
			}, delay)
      break
		case 'text':
			tl.fromTo(element.querySelectorAll('.line'), {
				yPercent: 130
			}, {
				yPercent: 0,
				duration: 2,
				stagger: 0.06,
				ease: 'expo',
			}, delay)
			break
		case 'fade':
			tl.fromTo(element, {
				opacity: 0,
				y: 25
			}, {
				opacity: 1,
				y: 0,
				duration: 1,
				ease: 'power2.out',
			}, delay)
      break
		case 'blur':
			tl.fromTo(element, {
				filter: 'blur(8px)'
			}, {
				filter: 'blur(0px)',
				duration: 1,
				ease: 'power2.out',
			}, delay)
			break;
		case 'image-scale':
			tl.fromTo(element.querySelector('picture'), {
				scale: 1.2,
				opacity: 0,
				filter: 'blur(6px)',
			}, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				duration: 1.8,
				ease: 'power2.out',
			}, delay)
			break
  }
}

export default () => {}